// Suggested code may be subject to a license. Learn more: ~LicenseLog:4252629569.
import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";

import HotArticle from "../components/HotArticle";
import Message from "../components/Message";
import ArticleSection from "../components/ArticlePage/ArticleSection";
import ProkerSection from "../components/ProkerPage/ProkerSection";
import ExtraSection from "../components/ExtraPage/ExtraSection";
import CommentPolicy from "../components/commentPolicy/CommentPolicy";

import ArticleDetail from "../components/ArticlePage/Article/ArticleDetail";
import ProkerDetail from "../components/ProkerPage/Proker/ProkerDetail";
import ExtraDetail from "../components/ExtraPage/Extra/ExtraDetail";

import Footer from "../components/Footer";

export default function LayoutPage({ type = "article" }) {
    const [articles, setArticles] = useState([]);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        const fetchArticles = async () => {
            const Articles = await window.apiClient('/data/article/3/1');
            setArticles(Articles.data.data);
        };

        const fetchMessages = async () => {
            const Messages = await window.apiClient('/data/message');
            setMessages(Messages.data);
        };

        fetchArticles();
        fetchMessages();
    }, []);

    const MainSection = {
        article: <ArticleSection/>,
        proker: <ProkerSection/>,
        extra: <ExtraSection/>,
        articleDetail: <ArticleDetail />,
        prokerDetail: <ProkerDetail />,
        extraDetail: <ExtraDetail />,
        commentPolicy: <CommentPolicy />
    }[type] || <ArticleSection/>;

    return <>
        <Header />
        <section className="px-4 py-8 bg-gray-100 min-h-svh" id="about">
            <div className="container mx-auto">
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    <div className="md:col-span-2">
                        {MainSection}
                    </div>
                    <div>
                        <HotArticle articles={articles} />
                        {/* Pesan dan Kesan */}
                        <Message messages={messages} />
                    </div>
                </div>
            </div>
        </section>
        {/* <Article /> */}
        <Footer />
    </>
}
